/**
* @file 财务中心-机构账单
* */
<template>
  <div id="order">
    <custom-table has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns"
      excel-type="OrganizationHitchRideBill" labelWidth="135" :summaryList="summaryList">
      <template slot="search-bottom">
        <div class="blueInfo">
          <p>* 每月1号生成上月账单</p>
          <p>* 上月订单中，乘客未确认下车的订单默认记录至下月账单中。</p>
        </div>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" width="140" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="actionFn({ type: 'detail', row: row })">账单
            </el-button>
            <el-button type="text" v-if="row.status != 2" @click="actionFn({ type: 'invoice', row: row })">开票
            </el-button>
            <el-button v-if="mixinUserInfo.organizationType == 1 && row.status == 3" type="text"
              @click="actionFn({ type: 'settlement', row: row })">结算
            </el-button>
          </div>
        </el-table-column>
      </template>

      <template v-slot:table-header="item">
        <template v-if="item.prop == 'realRebateAmount'">
          实际返佣
          <el-tooltip class="item" effect="dark" content="实际返佣 = 平台返佣 - 信息费 - （退款金额×返佣比例-退款订单信息费）" placement="top">
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </template>
        <template v-else>{{ item.label }}</template>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'created'">{{ row[item.prop] | filterTime }}</template>
        <template v-else-if="item.prop == 'billTime'">{{ row[item.prop] | filterTime("YYYY/MM") }}</template>
        <template v-else-if="['cooperationRatio', 'rebateRatio'].includes(item.prop)">{{ row[item.prop] }}%</template>
        <template v-else-if="item.prop == 'invoice'">
          <el-button v-if="row[item.prop]" type="text" @click="openPdf(row)">查看</el-button>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop == 'status'">
          <span :style="{ color: row[item.prop] != 2 ? '' : '#66CC00' }">{{
            row[item.prop] | filterBillStatus
          }}</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <el-dialog v-if="visible" :visible.sync="visible" title="账单明细" width="80%">
      <custom-table has-organization="true" ref="dialogCustomTable" :customOptions="dialogTableOptions"
        :columns="dialogTableColumns" excel-type="OrganizationHitchRideBillDetail" style="height: 70vh"
        :columnsSettingshow="true">
        <template slot-scope="{ item, row }">
          <template v-if="['created', 'finishTime', 'reachTime'].includes(item.prop)">
            {{ row[item.prop] | filterTime }}
          </template>
          <template v-else-if="item.prop == 'orderNo'">
            <span class="link" @click="actionFn({ type: 'look', row: row })" @dblclick="$utils.dblclickCopy">{{
              row[item.prop] }}</span>
          </template>
          <template v-else-if="item.prop == 'partnerOrderId'">
            <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
          </template>
          <template v-else-if="item.prop == 'realPhoneSuffix'">
            <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] }}</span>
          </template>
          <template v-else-if="item.prop == 'licenseNo'">
            <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(row.licenseNo) }}</span>
            <span v-else>-</span>
          </template>
          <template v-else-if="item.prop == 'driverName'">
            <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
          </template>
          <template v-else-if="item.prop == 'driverPhone'">
            <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
          </template>

          <template v-else-if="item.prop === 'startCity'">
            <div>{{ row.startCity }}</div>
          </template>
          <template v-else-if="item.prop === 'startPointName'">
            <div>{{ row.startPointName }}</div>
            <div style="color: #999">{{ row.startPointAddress }}</div>
          </template>
          <template v-else-if="item.prop === 'endCity'">
            <div>{{ row.endCity }}</div>
          </template>
          <template v-else-if="item.prop === 'endPointName'">
            <div>{{ row.endPointName }}</div>
            <div style="color: #999">{{ row.endPointAddress }}</div>
          </template>
          <template v-else-if="item.prop == 'status'">
            <el-tag size="small" :type="row.status | filterConst('HITCHHIKINGDAN', 'type')">{{ row.status |
              filterConst('HITCHHIKINGDAN') }}</el-tag>
          </template>
          <template v-else-if="item.prop == 'poolType'">
            <el-tag :type="row.poolType == 1 ? 'primary' : 'success'" size="small">{{ row.poolType == 1 ? '独享' : '拼车' }}</el-tag>
          </template>
          <template v-else-if="item.prop == 'cityType'">
            <el-tag :type="row.cityType == 1 ? 'warning' : 'success'" size="small">{{ row.cityType == 1 ? '城际' : '市内' }}</el-tag>
          </template>
          <template v-else-if="item.prop == 'channelAlias'">
            {{ row.channelAlias | filterConst("HITCHHIKINGCHANNEL") }}
          </template>

          <template v-else-if="item.prop == 'vehicleSeat'">{{ row.vehicleSeat }}座</template>
          <template v-else-if="item.prop == 'amount'">
            <span class="util-money"> ¥{{ row.amount || 0 }} </span>
          </template>
          <template v-else-if="item.prop == 'cancelFee'">
            <span v-if="row.cancelFee">
              <span class="util-money">¥{{ row.cancelFee || 0 }}</span><span v-if="row.cancelRatio">({{ row.cancelRatio
                }}取消费率)</span>
            </span>
            <span v-else>-</span>
          </template>

          <template v-else-if="item.prop == 'commissionAmount'">
            <span class="util-money"> ¥{{ row.commissionAmount || 0 }} </span>
          </template>
          <template v-else>{{
            row[item.prop] ? row[item.prop] : "-"
          }}</template>
        </template>
      </custom-table>
    </el-dialog>
    <!-- 开票弹窗 -->
    <el-dialog :visible.sync="invoiceVisible" title="机构开票" width="430px" :close-on-click-modal="false">
      <el-form :model="rowData" ref="form" label-width="0" v-if="!rowData.invoice">
        <el-form-item label="" prop="invoice">
          <upload_pdfs :max="1" :urls.sync="rowData.invoice"> </upload_pdfs>
        </el-form-item>
      </el-form>
      <div class="flex-between" style="margin-bottom: 10px" v-else>
        <span style="cursor: pointer" @click="openPdf(rowData)">{{
          Array.isArray(rowData.invoice)
            ? rowData.invoice[0].name
            : rowData.invoice
        }}</span>
        <i style="color: #409eff; cursor: pointer" class="el-icon-close" @click="delInvoice"></i>
      </div>
      <div style="font-size: 14px">
        <span>账单结算前，请确认账单后上传电子发票。</span>
        <span style="color: #409eff; cursor: pointer" @click="invoiceInfoVisible = true">查看开票信息</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="invoiceVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveInvoice" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 开票信息弹窗 -->
    <el-dialog :visible.sync="invoiceInfoVisible" title="开票信息" width="430px">
      <el-form>
        <el-form-item label="公司名称：">智慧云行（成都）科技有限公司</el-form-item>
        <el-form-item label="统一社会信用代码：">91510115MA6BL9J08M</el-form-item>
        <el-form-item label="联系电话：">19113533571</el-form-item>
        <el-form-item label="电子邮箱：">shunfengxia@zhihuiyunxing.com</el-form-item>
        <el-form-item label="注册地址：">成都市武侯区智星三路331号1层</el-form-item>
        <el-form-item label="开票内容：">技术服务费</el-form-item>
        <el-form-item label="开票类型：">增值税普通发票</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 100%" type="primary" size="large" @click="invoiceInfoVisible = false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import upload_pdfs from "@/components/pdf/upload_pdfs";
export default {
  name: "order",
  components: {
    upload_pdfs,
  },
  data() {
    return {
      loading: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/organization/hitchRide/bill",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "select",
            field: "status",
            name: "账单状态",
            value: "",
            option: this.$const.BILLSTATUS,
          },
          {
            type: "date",
            dateType: "month",
            field: "billTime",
            name: "账期",
            value: "",
          },
        ],
      },
      // 表头
      columns: [
        { prop: "billTime", label: "账期", minWidth: 100 },
        { prop: "finishOrderNum", label: "完成订单", minWidth: 80 },
        { prop: "refundOrderNum", label: "退款订单", minWidth: 80 },
        { prop: "totalAmount", label: "成交金额", minWidth: 80 },
        { prop: "refundAmount", label: "退款金额", minWidth: 80 },
        { prop: "cooperationRatio", label: "抽佣比例", minWidth: 80 },
        { prop: "cooperationAmount", label: "平台抽佣", minWidth: 80 },
        { prop: "rebateRatio", label: "返佣比例", minWidth: 80 },
        { prop: "rebateAmount", label: "平台返佣", minWidth: 80 },
        { prop: "serviceFee", label: "信息费", minWidth: 80 },
        { prop: "realRebateAmount", label: "实际返佣", minWidth: 100 },
        { prop: "status", label: "状态", minWidth: 100 },
        { prop: "invoice", label: "电子发票", minWidth: 100 },
        { prop: "created", label: "出账时间", minWidth: 120 },
      ],
      summaryList: [
        { name: "finishOrderNum" },
        { name: "totalAmount" },
        { name: "cooperationAmount" },
        { name: "rebateAmount" },
        { name: "serviceFee" },
        { name: "realRebateAmount" },
      ],
      visible: false,
      // 配置项
      dialogTableOptions: {
        // 请求的列表url
        url: "/api/v1/manage/organization/hitchRide/bill/detail",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
      },
      // 表头
      dialogTableColumns: [
        { prop: "status", label: "订单状态", minWidth: 100 },
        { prop: "orderNo", label: "订单号", minWidth: 190 },
        { prop: "startCity", label: "出发城市", minWidth: 80 },
        { prop: "startPointName", label: "出发地址", minWidth: 200 },
        { prop: "endCity", label: "目的城市", minWidth: 80 },
        { prop: "endPointName", label: "目的地址", minWidth: 200 },
        { prop: "realPhoneSuffix", label: "乘客", minWidth: 80 },
        { prop: "driverName", label: "司机姓名", minWidth: 80 },
        { prop: "licenseNo", label: "车辆号牌", minWidth: 80 },
        { prop: "finishTime", label: "完成/取消时间", minWidth: 130 },
        { prop: "reachTime", label: "乘客确认下车时间", minWidth: 130 },
        { prop: "amount", label: "订单金额", minWidth: 100 },
        { prop: "commissionAmount", label: "司机收入", minWidth: 90 },
        { prop: "serviceFee", label: "信息费", minWidth: 90 },
        { prop: "partnerOrderId", label: "三方订单号", minWidth: 120 },
      ],
      invoiceVisible: false,
      rowData: {},
      invoiceInfoVisible: false,
    };
  },
  methods: {
    openPdf(row) {
      if (!row.invoice) {
        return
      }
      window.open(
        this.mixinQiniuImg(
          Array.isArray(row.invoice)
            ? row.invoice[0].name
            : row.invoice
        )
      );
    },
    delInvoice() {
      this.rowData.invoice = "";
    },
    actionFn({ type, row }) {
      switch (type) {
        case "detail":
          this.dialogTableOptions.params.page = 1;
          this.dialogTableOptions.params.id = row.id;
          this.dialogTableOptions.params.organizationId = row.id;
          this.visible = true;
          break;
        case "settlement":
          this.$confirm(
            "请确认当前账单是否已经与机构名称结算？确认结算后账单状态将变更为：已结算",
            "账单结算",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          ).then(async () => {
            const url = "/api/v1/manage/organization/hitchRide/bill/settle";
            const { code } = await this.$axios.post(url, { id: row.id });
            if (code === 1) {
              this.$message.success("操作成功");
              this.$refs.customTable.listFn();
            }
          });
          break;
        case "invoice":
          this.invoiceVisible = true;
          this.rowData = { ...row };
          break;
      }
    },
    async saveInvoice() {
      if (!this.rowData.invoice) {
        this.$message.warning("请上传发票文件");
        return;
      }
      const url = "/api/v1/manage/organization/hitchRide/bill/invoice";
      const params = {
        id: this.rowData.id,
        invoice: Array.isArray(this.rowData.invoice)
          ? this.rowData.invoice[0].url
          : this.rowData.invoice,
      };
      const { code } = await this.$axios.post(url, params);
      if (code == 1) {
        this.$message.success("上传成功！");
        this.invoiceVisible = false;
        this.$refs.customTable.listFn();
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += " 元";
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
  },
};
</script>

<style scoped lang="less">
#order {
  ::v-deep .el-upload {
    width: 100%;
  }

  ::v-deep .el-upload-dragger {
    width: 100%;
  }
}
</style>
